/**
 * Provider for `lists`
 * @module
 */
var _ = require('optimizely-client-fn');

var Cookie = require('core/utils/cookie');
var enums = require('core/constants/enums');
var Logger = require('core/utils/logger');
var Query = require('core/utils/query');
var WindowEnv = require('core/env/window');

/**
 * @type {DataProvider}
 */
module.exports = {
  provides: 'lists',

  isAsync: true,

  getter: [
    'stores/global',
    'sources/odds',
    function(GlobalStore, ODDSSource) {
      return function(getValue, setValue) {
        var listTargetingKeys = GlobalStore.getListTargetingKeys();
        var curMetadata = (getValue() || {}).metadata || {};

        var listTargetingLocatorData = _.reduce(listTargetingKeys, function(res, locator) {
          var listTargetingLocatorValue = getLocatorValue(locator);
          var locatorKey = [locator.type, locator.key].join('_');

          if (curMetadata[locatorKey] !== listTargetingLocatorValue) {
            // Invalidate the cached data, because some locator doesn't match its previous value (even if undefined)
            setValue(undefined);
          }

          if (listTargetingLocatorValue) {
            res[locatorKey] = listTargetingLocatorValue;
          }

          return res;
        }, {});

        return ODDSSource.fetchListMemberships(GlobalStore.getProjectId(), listTargetingLocatorData);
      };
    },
  ],
};

/**
 * @param {ListTargetingKey} locator
 * @return {string|undefined} If value found for locator, return (encoded) value for that locator. Else return undefined.
 * @private
 */
function getLocatorValue(locator:ListTargetingKey): string|undefined {
  var val;
  var valIsEncoded = false;

  switch (locator.type) {
    case enums.ListTargetingKeyTypes.QUERY:
      // Returns a value encoded
      val = Query.getQueryParamValue(locator.key);
      valIsEncoded = true;
      break;
    case enums.ListTargetingKeyTypes.COOKIE:
      // Returns a value encoded
      val = Cookie.get(locator.key, false);
      valIsEncoded = true;
      break;
    case enums.ListTargetingKeyTypes.JS_VARIABLE:
      // Returns a not-encoded value
      val = WindowEnv.getGlobal(locator.key);
      if (!(_.isUndefined(val) || _.isNull(val) || _.isString(val) || _.isBoolean(val) || _.isNumber(val))) {
        Logger.warn('List locator value must be string, bool, or Number. Omitting value for', locator.key);
        val = undefined;
      }
      break;
    default:
      // should never happen
      throw new Error('Unknown list targeting key type: ' + locator.type);
  }

  if (_.isUndefined(val) || _.isNull(val)) {
    return;
  }

  val = String(val);
  if (!valIsEncoded) {
    val = encodeURIComponent(val);
  }
  if (val.length > 100) {
    Logger.warn('Withholding overlong value for', locator.name, '(type: ' + locator.type + ')');
    return;
  }

  return val;
}
